// these Waypoint functions are internal to xps-react for working with the Waypoint module
import memoize from 'memoize-one';
export var showWaypoint = memoize(function (index, dataLength, defaultPageSize, virtualScroll) {
  if (!virtualScroll) {
    return false;
  }

  if (index + defaultPageSize * 2 < dataLength) {
    return true;
  }

  return false;
});
export var showWaypointUp = memoize(function (index, virtualScroll) {
  if (!virtualScroll) {
    return false;
  }

  if (index > 0) {
    return true;
  }

  return false;
});